import React, { Component } from 'react';
import ModalForm from '../../comum/components/ModalForm';
import { Button, Row, Col, CardTitle, Label } from 'reactstrap'
import FormInputSimples from '../../comum/components/FormInputSimples';
import FormInputNumber from '../../comum/components/FormInputNumber';
import FormSelectSimples from '../../comum/components/FormSelectSimples';
import CardAtencao from '../../comum/components/CardAtencao';
import CheckboxField from '../../comum/components/CheckboxField';
import Checkbox from '../../comum/components/Checkbox';
import ModalAviso from '../../comum/components/ModalAviso';
import { observer } from 'mobx-react';

@observer
export default class ModalAverbacao extends Component {
    /* Ajuste para publicação */
    constructor(props) {
        super(props)

        this.controller = this.props.controller;
        this.state = {
            showModalTermosDesistencia: false,
            salvo: false
        }
        this.verdadeiro = "V";
        this.falso = "F"

        this.OnChangeTermoDesistencia = this.OnChangeTermoDesistencia.bind(this);
        this.validar = this.validar.bind(this);
    }

    AbrirTermoDesistencia = () => {
        this.setState({ showModalTermosDesistencia: true })
    }

    FecharTermoDesistencia = () => {
        this.controller.dadosAverbacao.Deacordo = this.falso;
        this.setState({ showModalTermosDesistencia: false });
    }

    AceitarTermoDesistencia = () => {
        this.controller.dadosAverbacao.Deacordo = this.verdadeiro;
        this.setState({ showModalTermosDesistencia: false });
    }

    OnChangeTermoDesistencia = () => {

        this.controller.dadosAverbacao.Deacordo = this.controller.dadosAverbacao.Deacordo === this.verdadeiro ? this.falso : this.verdadeiro;
    }

    SalvarAverbacao = async () => {
        this.setState({ salvo: true });
        if (this.validar()){
            let averbacaoSalva = await this.controller.salvarAverbacao();           
        }
    }

    ModalTermoDesistencia = () => {
        return (
            this.state.showModalTermosDesistencia &&
            <ModalForm
                className="tamanho-modal-500"
                labelConfirmar="LI E ACEITO OS TERMOS"
                labelCancelar="Cancelar"
                onClickSalvar={() => this.AceitarTermoDesistencia()}
                onClickCancelar={() => this.FecharTermoDesistencia()}
            >
                <h2>Termos de desistência</h2>
                <span>
                    O Importador acima mencionado, através de seu representante abaixo assinado, DESISTE da vistoria dos volumes acima citados, assumindo inteira
                    responsabilidade pelo ônus decorrente desta desistência e DECLARA concordar que após a retirada da carga das dependências do TECON RIO GRANDE
                    S/A, o referido terminal está isento de qualquer responsabilidade sobre o conteúdo da carga, razão pela qual, em nenhuma hipótese poderá
                    ser responsabilizado por qualquer custo e/ou dano direto ou indireto.
                </span>
            </ModalForm>
        );
    }

    validar = () => {
        return (
            this.controller.dadosAverbacao && 
            this.controller.dadosAverbacao.Di &&
            this.controller.dadosAverbacao.Di.length >= 10 &&
            this.controller.despachanteSelecionado && 
            this.controller.tipoProcessoSelecionado
        );
    }

    componentDidMount = () => {
        if (this.controller.processoAverbado) 
        {
            this.despachanteDidMount();
        }
    }

    despachanteDidMount = () => {
        if (this.controller.dadosAverbacao.DspId) {
            this.controller.despachanteSelecionado = {};
            this.controller.despachanteSelecionado.label = this.controller.dadosAverbacao.ApelidoDespachante;
            this.controller.despachanteSelecionado.value = this.controller.dadosAverbacao.DspId;
            this.controller.setDespachanteAverbacao(this.controller.despachanteSelecionado);         
        }
    }

    DeacordoDidMount = () => {
        if (this.controller.dadosAverbacao.Deacordo)
            this.controller.dadosAverbacao.Deacordo = "V";
    }

    exibeMsgDesistencia = () => {
      let msg= (
                <Row>
                    <div className="modal-termos-desistencia">
                        <div>
                            <span className={this.controller.processoAverbado ? "label-disabled" : ""}> 
                                Desejo desistir da vistoria e estou da acordo com os <span className={this.controller.processoAverbado ? "" : "link link--underline"} onClick={() => {if (!this.controller.processoAverbado) this.AbrirTermoDesistencia()}}>termos de desistência</span>.
                            </span>
                        </div>                                
                        <Checkbox onClick={this.OnChangeTermoDesistencia} 
                                ativo={this.controller.dadosAverbacao.Deacordo === this.verdadeiro ? true : false} 
                                bloqueado={this.controller.processoAverbado}
                        />
                    </div>
                </Row>
                );

        if (process.env.rig && ["I"].includes(this.controller.tipoAcompanhamento) && this.controller.dadosProcesso.FlagAvaria === 'F')
        {
            msg = (<div />);
        }
        
        return msg;
    }

    render() {
        return (
            this.ModalTermoDesistencia() ||
            <ModalForm
                className="tamanho-modal-1000"
                esconderSalvar = {this.controller.processoAverbado}
                labelConfirmar="SALVAR"
                labelCancelar={this.controller.processoAverbado ? "VOLTAR" : "CANCELAR"}
                onClickSalvar={() => this.SalvarAverbacao()}
                onClickCancelar={() => this.controller.fecharAverbacao()}
            >
                <h2>Averbação</h2>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <Row>
                            <FormSelectSimples titulo="Despachante" xl={12} lg={12} md={12} sm={12} xs={12}
                                itens={this.controller.listaDespachanteUsuario}
                                dado={this.controller.despachanteSelecionado}
                                bloqueado={this.controller.processoAverbado}
                                obrigatorio={!this.controller.processoAverbado}
                                alerta={!this.validar() && this.state.salvo ? "Campo obrigatório" : false}
                                onChange={(event) => this.controller.setDespachanteAverbacao(event)}
                                naoLimpar={false}
                            />
                            <FormSelectSimples titulo="Tipo de processo" xl={12} lg={12} md={12} sm={12} xs={12}
                                itens={this.controller.listaProcessos}
                                dado={this.controller.tipoProcessoSelecionado}
                                bloqueado={this.controller.processoAverbado}
                                obrigatorio={!this.controller.processoAverbado}
                                alerta={!this.validar() && this.state.salvo ? "Campo obrigatório" : false}
                                onChange={(event) => this.controller.setTipoProcesso(event)}
                                naoLimpar={false}
                            />
                            <FormInputNumber titulo="Número do processo da DI" xl={12} lg={12} md={12} sm={12} xs={12}
                                dado={this.controller.dadosAverbacao.Di}
                                bloqueado={this.controller.processoAverbado}
                                obrigatorio={!this.controller.processoAverbado}
                                onChange={(event) => this.controller.onChangeNumeroProcessoDi(event)}
                                alerta={!this.validar() && this.state.salvo ? "Campo obrigatório" : false}
                                limiteMaximo={10}
                                limiteMinimo={10}
                            />
                        </Row>
                    </Col>

                    <Col xs={12} md={6} lg={6}>
                        <Label className="invisible">no title</Label>
                        <Row>
                            <CardAtencao>
                                <span>
                                    Por favor, confira se os dados do BL estão de acordo com o processo (CNPJ e Razão Social). <br />
                                    Qualquer divergência, contacte o Import Desk.
                                </span>
                            </CardAtencao>
                        </Row>
                        {this.exibeMsgDesistencia()}
                    </Col>
                </Row>                
            </ModalForm>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/ModalAverbacao.js